/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Maximum_Gap_AllowedInputs */

const en_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximum gap allowed between frames`)
};

const fr_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Écart maximum autorisé entre les images`)
};

const de_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maximal zulässiger Abstand zwischen den Bildern`)
};

const it_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spazio massimo consentito tra i telai`)
};

const ru_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Максимально допустимый зазор между рамками`)
};

const es_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espacio máximo permitido entre marcos`)
};

const zh_cn2_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`帧之间允许的最大间距`)
};

const ja_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`フレーム間の最大許容ギャップ`)
};

const hi_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`फ़्रेमों के बीच अधिकतम अनुमत अंतराल`)
};

const pt_pt2_maximum_gap_allowed = /** @type {(inputs: Maximum_Gap_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Espaço máximo permitido entre quadros`)
};

/**
* | output |
* | --- |
* | "Maximum gap allowed between frames" |
*
* @param {Maximum_Gap_AllowedInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const maximum_gap_allowed = /** @type {((inputs?: Maximum_Gap_AllowedInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Maximum_Gap_AllowedInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_maximum_gap_allowed(inputs)
	if (locale === "de") return de_maximum_gap_allowed(inputs)
	if (locale === "it") return it_maximum_gap_allowed(inputs)
	if (locale === "ru") return ru_maximum_gap_allowed(inputs)
	if (locale === "es") return es_maximum_gap_allowed(inputs)
	if (locale === "zh-CN") return zh_cn2_maximum_gap_allowed(inputs)
	if (locale === "ja") return ja_maximum_gap_allowed(inputs)
	if (locale === "hi") return hi_maximum_gap_allowed(inputs)
	if (locale === "pt-PT") return pt_pt2_maximum_gap_allowed(inputs)
	return en_maximum_gap_allowed(inputs)
});